import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import ContentRow from '../content-row';
export var styles = function styles(_ref) {
  var spacing = _ref.spacing,
      mixins = _ref.mixins,
      palette = _ref.palette;
  return {
    root: _objectSpread({}, mixins.flex('center', 'flex-end'), {
      flex: '0 0 auto',
      padding: spacing(1),
      borderTop: "1px solid ".concat(palette.divider)
    })
  };
}; // eslint-disable-next-line prefer-arrow-callback

export var ModalActions = React.forwardRef(function ModalActions(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      rest = _objectWithoutProperties(props, ["children", "classes", "className"]);

  return React.createElement(ContentRow, _extends({
    className: classNames(classes.root, className),
    ref: ref
  }, rest), children);
});
process.env.NODE_ENV !== "production" ? ModalActions.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
} : void 0;
ModalActions.defaultProps = {
  className: null,
  children: null
};
export default withStyles(styles, {
  name: 'ModalActions'
})(ModalActions);